import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import recipesEn from './locales/en/recipes.json';
import mealPlanEn from './locales/en/mealPlan.json';
import shoppingEn from './locales/en/shopping.json';
import cookingEn from './locales/en/cooking.json';
import settingsEn from './locales/en/settings.json';

import commonRu from './locales/ru/common.json';
import authRu from './locales/ru/auth.json';
import recipesRu from './locales/ru/recipes.json';
import mealPlanRu from './locales/ru/mealPlan.json';
import shoppingRu from './locales/ru/shopping.json';
import cookingRu from './locales/ru/cooking.json';
import settingsRu from './locales/ru/settings.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    recipes: recipesEn,
    mealPlan: mealPlanEn,
    shopping: shoppingEn,
    cooking: cookingEn,
    settings: settingsEn,
  },
  ru: {
    common: commonRu,
    auth: authRu,
    recipes: recipesRu,
    mealPlan: mealPlanRu,
    shopping: shoppingRu,
    cooking: cookingRu,
    settings: settingsRu,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS,
    ns: ['common', 'auth', 'recipes', 'mealPlan', 'shopping', 'cooking', 'settings'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'food-tracker-language',
      caches: ['localStorage'],
    },
  });

export default i18n;
